import p from"styled-components";import{theme as i}from"../../../theme.js";const n=p.div`
  width: fit-content;
  font-size: 12px;
  line-height: 14px;
  color: ${({color:o})=>o};
  background-color: ${({backgroundColor:o})=>o};
  border-radius: ${i.radius}px;
  padding: ${i.spacing}px ${i.spacing*2}px;
  display: flex;
  align-items: center;
  gap: ${i.spacing}px;
  > svg {
    width: 14px;
    height: 14px;
    > g, path {
      fill: ${({color:o})=>o};
    }
  }
  > span {
    font-size: 12px;
    font-weight: 700;
    display: ${({labelOnHover:o})=>o?"none":"block"};
  }
  &:hover {
    > span {
      display: block;
    }
  }
`;export{n as Container};
